export default {
  Title: 'Dashboard'
}
